// /src/MainWebsite/Pages/Home/Components/StoryMission/StoryMission.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Classes from './StoryMission.module.css';
import { ArrowCircleIcon } from '../../../../../utils/Icons';

const fadeUp = {
    hidden: { opacity: 0, y: 18 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, ease: 'easeOut' },
    },
};

const imageIn = {
    hidden: { opacity: 0, scale: 0.97, filter: 'blur(4px)' },
    show: {
        opacity: 1,
        scale: 1,
        filter: 'blur(0)',
        transition: { duration: 0.55, ease: 'easeOut' },
    },
};

const stagger = {
    hidden: {},
    show: {
        transition: { staggerChildren: 0.12 },
    },
};

export default function StoryMission() {
    const navigate = useNavigate();

    const handleGetStarted = () => {
        navigate('/signup');
    };

    return (
        <motion.section
            id="story-mission"
            className={Classes.section}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.25 }}
            variants={stagger}
        >
            <motion.h1 className={Classes.subheading} variants={fadeUp} >
                Locally Owned - Veteran Found - Community Tested
            </motion.h1>

            <div className={Classes.inner}>
                {/* Row 1 – Our Story */}
                <motion.div className={Classes.row} variants={stagger}>
                    <motion.div className={Classes.copy} variants={fadeUp}>
                        <h3 className={Classes.title}>Our Story</h3>
                        <p className={Classes.desc}>
                            FuelClubs is a veteran-owned company proudly serving Las Vegas and
                            Henderson, Nevada. We started with a simple idea: make refueling
                            easier. By combining the personal touch of an old-school fuel
                            attendant with modern, on-demand service, we deliver fuel straight
                            to your vehicle, fleet, or equipment so you can skip the gas
                            station and keep your day moving.
                        </p>

                        <button className={Classes.cta} onClick={handleGetStarted}>
                            <h5>Get Started</h5>
                            <ArrowCircleIcon height="22" fill={'var(--primary-color)'} />
                        </button>
                    </motion.div>

                    <motion.div className={Classes.imageWrap} variants={imageIn}>
                        <LazyLoadImage
                            src="/assets/images/story-1.webp"
                            alt="FuelClubs technician refueling equipment"
                            effect="opacity"
                            className={Classes.image}
                            draggable={false}
                        />
                    </motion.div>
                </motion.div>

                {/* Row 2 – Our Mission */}
                <motion.div className={`${Classes.row} ${Classes.rowRev}`} variants={stagger}>
                    <motion.div className={Classes.imageWrap} variants={imageIn}>
                        <LazyLoadImage
                            src="/assets/images/story-2.webp"
                            alt="FuelClubs truck ready to refuel"
                            effect="opacity"
                            className={Classes.image}
                            draggable={false}
                        />
                    </motion.div>

                    <motion.div className={Classes.copy} variants={fadeUp}>
                        <h3 className={Classes.title}>Our Mission</h3>
                        <p className={Classes.desc}>
                            Our mission is to fuel your day with convenience, reliability, and
                            friendly service. Whether you&apos;re a busy parent, a business
                            owner, or anyone who values their time, FuelClubs is here to
                            provide safe, dependable on-site fueling wherever you need it.
                        </p>

                        <button className={Classes.cta} onClick={handleGetStarted}>
                            <h5>Get Started</h5>
                            <ArrowCircleIcon height="22" fill={'var(--primary-color)'} />
                        </button>
                    </motion.div>
                </motion.div>
            </div>
        </motion.section>
    );
}
